import { normalizeCompanyColorScheme, type NormalizedCompanyColorScheme } from 'zens-store'
import { Color } from 'zens-storybook'

export interface ColorSchemeLegendItem {
  key: string
  label: string
  color: string
}

const COLOR_SCHEME_ORDER: (keyof NormalizedCompanyColorScheme)[] = ['occupancy_colors', 'trigger_colors']

const titleForMeaning = (meaning: string) => meaning.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
export const colorForSchemeValue = (value: string | undefined) =>
  (value && Color[value as keyof typeof Color]) || Color.calmGrey

export function colorForTriggerValue(value: string | undefined, colorScheme: NormalizedCompanyColorScheme): string {
  const { occupancy_colors } = normalizeCompanyColorScheme(colorScheme)
  
  if (value && Object.values(occupancy_colors).includes(value)) {
    if (value === 'red') return Color.soothingPink
    if (value === 'green') return Color.darkRefinedGreen
  }
  
  return colorForSchemeValue(value)
}

export function legendItemsFromColorScheme(colorScheme: NormalizedCompanyColorScheme): ColorSchemeLegendItem[] {
  const normalizedColorScheme = normalizeCompanyColorScheme(colorScheme)
  const legendItems: ColorSchemeLegendItem[] = []
  
  for (const groupKey of COLOR_SCHEME_ORDER) {
    const group = normalizedColorScheme[groupKey]
    
    for (const [meaning, colorKey] of Object.entries(group)) {
      legendItems.push({
        key: `${groupKey}-${meaning}`,
        label: titleForMeaning(meaning),
        color:
          groupKey === 'trigger_colors'
            ? colorForTriggerValue(colorKey, normalizedColorScheme)
            : colorForSchemeValue(colorKey),
      })
    }
  }

  return legendItems
}
